import { useEffect, useState } from "react";
import { getDefectLogs } from "../../services/api";

export const useDefectLogs = (start: string, stop: string) => {
  const [defectLogs, setDefectLogs] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const getDefect = async () => {
      setLoading(true);
      try {
        const response = await getDefectLogs(start, stop);
        setDefectLogs(response?.data);
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    };
    getDefect();
  }, [start, stop]);

  return {
    defectLogs,
    loading,
  };
};
